import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { getFormattedPrice } from 'webapp/utils/number';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPromotionsGrowth2024PopupTrialStartedComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('billing') declare billingService: Service.Billing;
	@service('flow/promotions')
	declare flowPromotionsService: Service.Flow.Promotions;

	get promotion() {
		return this.flowPromotionsService.promotions.growthPlanDiscountOptionPromotion;
	}

	get showYearlyOption() {
		return !this.billingService.activePlan?.isYearly && this.billingService.yearlySavings > 0; // isPayingCustomer is a given
	}

	get totalYearlySavings() {
		return this.billingService.yearlySavings + (this.promotion?.totalDiscountAmmount ?? 0);
	}

	get formattedTotalYearlySavings() {
		return getFormattedPrice(this.totalYearlySavings);
	}

	@action
	openGrowthPromoUpgradePopup() {
		this.flowPromotionsService.openGrowthPromoUpgradePopup('promote_growth_plan_popup');
	}
	<template>
		<div class="content">
			<img
				class="promo-image"
				src="/images/billing/promotions/growth-2024.png"
				alt="Upgrade promo"
			/>

			<h4>LIMITED OFFER</h4>

			<h3>Upgrade now and save {{this.promotion.totalDiscountAmmountFormatted}}</h3>

			<p>
				Your free Growth plan trial has ended. Keep using all the Growth plan features by
				upgrading and
				<b>
					save
					{{this.promotion.totalDiscountAmmountFormatted}}
					within the next
					{{this.promotion.discountDurationInMonths}}
					months
				</b>.
			</p>

			<p>
				Upgrade by
				{{this.promotion.formattedActiveUntilMMMDo}}
				for a
				{{this.promotion.discountAmmountFormatted}}
				monthly discount in the first
				{{this.promotion.discountDurationInMonths}}
				months.<br />
				{{#if this.showYearlyOption}}
					<b>
						Pick yearly subscription for

						{{this.formattedTotalYearlySavings}}
						savings.
					</b>
				{{/if}}
			</p>

			<div class="footer">
				<a
					role="button"
					class="button size-big"
					{{on "click" this.openGrowthPromoUpgradePopup}}
				>
					Claim offer
				</a>
			</div>
		</div>
	</template>
}
